import { Component, OnInit, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import {
  TdSearchBoxComponent, ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService,
  TdDialogService, TdLoadingService, ITdDataTableSortChangeEvent, IPageChangeEvent
} from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { SettingsService } from '../../../../shared/services/settings.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { ExportService } from '../../../../shared/services/export.service';
import { MdDialogRef } from '@angular/material';
import { Utils } from '../../../../shared/utils';

import { Branch } from '../../branch';
import { BranchService } from '../../branches/branch.service';
import { Pallet } from '../pallet';
import { PalletService } from '../../../../shared/services/pallet.service';


@Component({
  selector: 'app-pallet-list',
  templateUrl: './pallet-list.component.html',
  styleUrls: ['./pallet-list.component.scss'],
  providers: [PalletService, BranchService]
})
export class PalletListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Pallet[];
  allPallets: Pallet[];

  allBranches$: Observable<Branch[]>;
  branchFilter: string = 'ALL';

  subscription: Subscription = new Subscription();
  columns: ITdDataTableColumn[] = [
    { name: 'id', label: 'Name' },
    { name: 'location_name', label: 'Location' },
    { name: 'total_pieces', label: 'Rolls' }
  ];

  filteredData: any[];
  filteredTotal: number;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;


  constructor(private _dataTableService: TdDataTableService,
    private _palletService: PalletService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
    public _authService: AuthenticationService) { }

  ngOnInit() {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscription = this._palletService
      .getPallets()
      .subscribe((pallets: Pallet[]) => {
        this.allPallets = pallets;

        this.data = this.allPallets.slice().filter(c => 
          { return this._authService.getUserBranches().some(b => { return c.location_branch_id == b.id }) });

        this.filter();
        this._loadingService.resolve('loading');

      }, error => {
        this._loadingService.resolve('loading');
      });

    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('bank')) {
      this._searchBox.value = this._settingsService.getSearchTerm('bank');
      this._searchBox.searchClicked();
    }
  }


  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;

    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;

    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('pallet', searchTerm);
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('pallet'), true, excludedColumns);

    if (this.branchFilter != 'ALL') {
      newData = newData.filter(d => { return d.location_branch_code == this.branchFilter; });
    }

    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/pallets/pallet-list/pallet-list.component.ts